import * as Schema from "effect/Schema";

import { AssetSha256 } from "./ids.js";

/**
 * SEO meta per page. v1 covers the 80% case (Google + social card
 * scrapers); JSON-LD / structured data deferred to v2 per PLAN.md.
 */
export const SeoMeta = Schema.Struct({
  title: Schema.optional(Schema.String),
  description: Schema.optional(Schema.String),
  ogImage: Schema.optional(AssetSha256),
  canonical: Schema.optional(Schema.String),
});
export type SeoMeta = Schema.Schema.Type<typeof SeoMeta>;
